import { useApp } from 'contexts/app';
import { useDialog } from 'contexts/dialog';
import { useViewport } from 'contexts/viewport';
import ErrorPage from 'pages/Error/404';
import Desktop from 'pages/ViewRubric/desktop';
import Mobile from 'pages/ViewRubric/mobile';
import Tablet from 'pages/ViewRubric/tablet';
import { useTranslation } from 'react-i18next';
import { useHistory, useParams } from 'react-router-dom';
import rubricService from 'services/rubric';
import { Loading } from 'shell/components';
import { exportRubricToCSV } from 'utils/helper';

const PageLayout = () => {
    const { rubrics, setRubrics } = useApp();
    const { setDialog, closeDialog } = useDialog();
    const history = useHistory();
    const params = useParams();
    const { device } = useViewport();
    const { t } = useTranslation('assignment');

    const rubric = rubrics?.find(({ id }) => id === params.id);

    const onClickBack = () => {
        history.push(`/rubrics`);
    };

    const onClickEdit = ({ id }) => {
        history.push(`/rubrics/${id}/edit`);
    };

    const onClickDownloadCSV = (rubric) => {
        exportRubricToCSV(rubric.rubric, t);
    };

    const onClickDelete = (rubricToDelete) => {
        setDialog({
            open: true,
            message: t('dialog.delete-rubric.title', 'Delete Rubric?'),
            description: t(
                'dialog.delete-rubric.description',
                'Deleting this rubric is permanent and cannot be undone.'
            ),
            note: '',
            variant: 'destructive',
            actionButtonText: t('common:controls.delete', 'Delete'),
            cancelButtonText: t('common:controls.cancel', 'Cancel'),
            onAction: () => {
                history.push(`/rubrics`);
                setRubrics((current) => {
                    return current.filter(({ id }) => id !== rubricToDelete.id);
                });
                closeDialog();
                rubricService.deleteRubric(rubricToDelete.id);
            },
            onCancel: () => closeDialog(),
            onClose: () => closeDialog(),
        });
    };

    const props = {
        rubric,
        onClickBack,
        onClickEdit,
        onClickDownloadCSV,
        onClickDelete,
    };

    const renderResponsiveLayout = (device) => {
        return {
            mobile: <Mobile {...props} />,
            tablet: <Tablet {...props} />,
            desktop: <Desktop {...props} />,
        }[device];
    };

    if (!rubrics) return <Loading />;

    if (!rubric) return <ErrorPage />;

    return renderResponsiveLayout(device);
};

export default PageLayout;
